import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Form } from 'src/app/services/forms/form';
import { PpstbService } from '../../ppstb.service';

@Component({
  selector: 'ppstb-main-s3',
  templateUrl: './ppstb-main-s3.component.html',
  styleUrls: ['./ppstb-main-s3.component.scss']
})
export class PpstbMainS3Component extends BaseComponent {

  @Input() form?: Form | null;
  @Input() disabled!: boolean;
  @Input() service?: PpstbService;


}
